//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
export default {
  props: {
    value: {
      default: 0
    },
    disabled: {
      default: false
    },
    popoverPlacement: {
      default: 'top'
    },
    popoverTitle: {
      default: '修改'
    },
    popoverWidth: {
      default: '150'
    },
    activeColor: {
      default: '#67C23A'
    },
    inactiveColor: {
      default: '#F56C6C'
    },
    activeText: {
      default: '正常'
    },
    inactiveText: {
      default: '禁用'
    },
    activeValue: {
      default: 1
    },
    inactiveValue: {
      default: 0
    },
    className: {
      default: ""
    }
  },
  data () {
    return {
      currentValue: this.value,
      currentDisabled: this.disabled
    }
  },
  watch: {
    value: {
      handler (val) {
        // console.log('watch.value', val)
        /*
        if (this.currentDisabled) {
        }
        */
        this.currentValue = val
        this.currentDisabled = false
      },
      immediate: true
    },
    disabled: {
      handler (val) {
        // console.log('disabled', val)
        this.currentDisabled = val
      },
      immediate: true
    }
  },
  methods: {
  }
}
